<h2 mat-dialog-title>Upload de CSV</h2>
<mat-dialog-content>
  <input type="file" (change)="onFileChange($event)" accept=".csv" />
  <div *ngIf="fileName">
    <p><strong>Arquivo selecionado:</strong> {{ fileName }}</p>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Cancelar</button>
  <button mat-button (click)="uploadFile()">Enviar</button>
</mat-dialog-actions>
